export const SDK_NAME = 'sentry.javascript.browser';
export const SDK_VERSION = '5.30.0';



// WEBPACK FOOTER //
// ../src/version.ts